<template>
  <el-card>
    <el-form inline ref="searchForm" :model="searchForm">
      <el-form-item prop="question">
        <el-input v-model="searchForm.question" placeholder="请输入问题" clearable></el-input>
      </el-form-item>
      <el-form-item prop="keyWord">
        <el-input v-model="searchForm.keyWord" placeholder="请输入关键词" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus" v-if="$ButtonShow('KFA_ADD_01')">新增自动问答</el-button>
      <el-button @click="onType" type="primary">客服电话设置</el-button>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="问题" show-overflow-tooltip prop="question" width="150"></el-table-column>
      <el-table-column label="关键词" show-overflow-tooltip prop="keyWord" width="150"></el-table-column>
      <el-table-column label="答案" show-overflow-tooltip prop="answer"></el-table-column>
      <el-table-column label="搜索次数" show-overflow-tooltip prop="searchCount" width="100"></el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.id)">查看</el-button>
          <el-button type="text" @click="onUpdate(row.id)" v-if="$ButtonShow('KFA_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onDelete(row.id)" v-if="$ButtonShow('KFA_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
    <ServiceType :isShowType.sync='isShowType'></ServiceType>
    <CustomerManageAdd v-if="isShowAdd" :isShowAdd.sync='isShowAdd' :id.sync="id" :title='title' @close="close">
    </CustomerManageAdd>
    <CustomerManageDetail v-if="isShowDetail" :isShowType.sync='isShowDetail' :id.sync="id" @close="id = ''">
    </CustomerManageDetail>
  </el-card>
</template>

<script>
import ServiceType from './ServiceType'
import CustomerManageAdd from './CustomerManageAdd'
import CustomerManageDetail from './CustomerManageDetail'
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'CustomerManage',
  mixins: [keepAlive],
  components: {
    ServiceType,
    CustomerManageAdd,
    CustomerManageDetail
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        question: '',
        keyWord: ''
      },
      isShowType: false,
      isShowAdd: false,
      isShowDetail: false,
      serviceList: [],
      id: '',
      title: '新增自动问答'
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    onType() {
      this.isShowType = true
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectKfAnswerByPage, {
          page: this.page,
          size: this.size,
          ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.title = '新增自动问答'
      this.isShowAdd = true
    },
    onUpdate(id) {
      this.title = '编辑自动问答'
      this.isShowAdd = true
      this.id = id
    },
    onDetail(id) {
      this.id = id
      this.isShowDetail = true
    },
    close() {
      this.id = ''
      this.loadData()
    },
    onDelete(id) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteKfAnswer, {
          id
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'></style>
